import { HOMEWORK_STATE } from '@/lib/utils';
import { getUser, login as loginAPI } from '@/services/generatedAPIs';
import { LoginRequest, UserInfoResponse, UserInfoResponseRole } from '@/services/generatedAPIs.schemas';
import { AuthContextType } from '@/types/types';
import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { init } from '@plausible-analytics/tracker';

// 创建 AuthContext
const AuthContext = createContext<AuthContextType | undefined>(undefined);
let schoolName: string = "";

init({
  domain: 'ease.eduhk.hk',
  autoCapturePageviews: true,
  customProperties: (eventName) => { return { schoolName: schoolName }}
})

// 创建一个 AuthProvider 组件
export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<UserInfoResponse | undefined>(sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')!) : undefined);
  if (user?.schoolName) {
    schoolName = user?.schoolName;
  }

  const setCurrentUser = (user: UserInfoResponse | undefined) => {

    setUser(user);
  };

  const getCurrentUser = (): UserInfoResponse | undefined => {
    return user;
  }

  // const validateCurrentUser = async (): Promise<UserInfoResponse | undefined> => {
  //   const token = localStorage.getItem('token');
  //   if (token) {
  //     const response = await getUser(token);
  //     if (response.code === 200) {
  //       setUser(response.data);
  //     }
  //     return response.data;
  //   }
  //   return undefined;
  // };

  const tokenLogin = async (): Promise<UserInfoResponse | undefined> => {
    const token = localStorage.getItem('token');
    if (token) {
        try {
          const res = await getUser(token);
          if (res && res.code === 200) {
            setCurrentUser(res.data);
            sessionStorage.setItem('user', JSON.stringify(res.data!));
            schoolName = user?.schoolName ?? "";
            return res.data!;
          }
        } catch(error) {
          return undefined;
        }
    }
    return undefined;
  }

  const login = async (request: LoginRequest): Promise<UserInfoResponse | undefined> => {
    const response = await loginAPI(request);
    if (response.code === 200) {
      setUser(response.data!.user);
      localStorage.setItem('token', response.data!.token);
      sessionStorage.setItem('user', JSON.stringify(response.data!.user));
      schoolName = response.data?.user.schoolName ?? "";
    }
    return user;
  };

  const logout = () => {
    setUser(undefined);
    HOMEWORK_STATE.itemId = undefined;
    HOMEWORK_STATE.tabId = undefined;
    localStorage.removeItem('token');
    sessionStorage.removeItem('user');
    schoolName = "";
  };

  const value: AuthContextType = {
    getCurrentUser,
    setCurrentUser,
    login,
    tokenLogin,
    logout,
    isLoggedIn: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// 自定义 Hook 来使用 AuthContext
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};